import { z } from 'zod';

export const ConfirmationSchema = z.object({
  id: z.string().uuid(),
});

export const ConfirmationEditSchema = z.object({
  candidateId: z.string().uuid(),
  availabilityPreferencesUpdated: z.boolean(),
});

export type Confirmation = z.infer<typeof ConfirmationSchema>;
export type ConfirmationEdit = z.infer<typeof ConfirmationEditSchema>;
